const warehouseLabels = [
    {
        title: 'Información General',
        type: 'columns',
        fields: [
            { label: '[NUMERO]', description: 'number', visible: true },
            { label: '[REMITENTE]', description: 'shipper_name', visible: true },
            { label: '[DESTINATARIO]', description: 'receiver_name', visible: true },
            { label: '[NOMBREEMPRESA]', description: 'company_name', visible: true },
            { label: '[DETALLES]', description: 'description', visible: true },
            { label: '[TIPOENVIO]', description: 'instruction', visible: true },
            { label: '[FECHACREACION]', description: 'creation_date', visible: true }
        ]
    },
    {
        title: 'Agency',
        type: 'columns',
        fields: [
            { label: '[NOMBREAGENCIA]', description: 'agency_name', visible: true },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            { label: '[EMAILAGENCIA]', description: 'agency_email', visible: true },
            { label: '[TELEFONOAGENCIA]', description: 'agency_phone', visible: true }
        ]
    },
    {
        title: 'Links',
        type: 'columns',
        fields: [
            { label: '[LINKCASILLERO]', description: 'link_pobox', visible: true },
            { label: '[LINKTRACKING]', description: 'link_tracking', visible: true },
            { label: '[LINKEMPRESA]', description: 'link_company', visible: true },
            {
                label: '[CAMBIOTIPOENVIO]',
                description: 'change_instruction_link',
                visible: true
            },
            {
                label: '[ENLACETRACKING]',
                description: 'link_tracking',
                visible: true
            },
            { label: '[URLEMPRESA]', description: 'link_company', visible: true },
            { label: '[ENLACEFIRMA]', description: 'link_signature', visible: true }
        ]
    },
    {
        title: 'Consignee',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREDESTINATARIO]',
                description: 'receiver_fullname',
                visible: true
            },
            {
                label: '[DIRECCIONDESTINATARIO]',
                description: 'receiver_address',
                visible: true
            },
            {
                label: '[CASILLERODESTINATARIO]',
                description: 'receiver_pobox',
                visible: true
            },
            {
                label: '[MOVILDESTINATARIO]',
                description: 'receiver_mobile',
                visible: true
            },
            {
                label: '[PAISDESTINATARIO]',
                description: 'receiver_country',
                visible: true
            },
            {
                label: '[ESTADODESTINATARIO]',
                description: 'receiver_state',
                visible: true
            },
            {
                label: '[DOCIDDESTINATARIO]',
                description: 'receiver_docid',
                visible: true
            }
        ]
    },
    {
        title: 'Shipper',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREREMITENTE]',
                description: 'shipper_fullname',
                visible: true
            },
            {
                label: '[DIRECCIONREMITENTE]',
                description: 'shipper_address',
                visible: true
            },
            {
                label: '[CASILLEROREMITENTE]',
                description: 'shipper_pobox',
                visible: true
            },
            {
                label: '[MOVILREMITENTE]',
                description: 'shipper_mobile',
                visible: true
            },
            {
                label: '[PAISREMITENTE]',
                description: 'shipper_country',
                visible: true
            },
            {
                label: '[ESTADOREMITENTE]',
                description: 'shipper_state',
                visible: true
            },
            { label: '[DOCIDREMITENTE]', description: 'shipper_docid', visible: true }
        ]
    },
    {
        title: 'Notes and References',
        type: 'columns',
        fields: [
            { label: '[NOTAWR]', description: 'note', visible: true },
            { label: '[REFERENCIAWR]', description: 'aux', visible: true }
        ]
    },
    {
        title: 'Customer',
        type: 'columns',
        fields: [
            { label: '[NOMBRECLIENTE]', description: 'customer_name', visible: true },
            {
                label: '[APELLIDOCLIENTE]',
                description: 'customer_lastname',
                visible: true
            },
            {
                label: '[DIRECCIONCLIENTE]',
                description: 'customer_address',
                visible: true
            },
            { label: '[CIUDADCLIENTE]', description: 'customer_city', visible: true },
            {
                label: '[ESTADOCLIENTE]',
                description: 'customer_state',
                visible: true
            },
            {
                label: '[PAISCLIENTE]',
                description: 'customer_country',
                visible: true
            },
            { label: '[EMAILCLIENTE]', description: 'customer_email', visible: true },
            {
                label: '[MOVILCLIENTE]',
                description: 'customer_mobile',
                visible: true
            },
            {
                label: '[TELEFONOCLIENTE]',
                description: 'customer_phone',
                visible: true
            },
            {
                label: '[CASILLEROCLIENTE]',
                description: 'customer_pobox',
                visible: true
            }
        ]
    },
    {
        title: 'Additional Information',
        type: 'columns',
        fields: [
            { label: '[ELEMENTTYPE]', description: 'element_type', visible: true },
            { label: '[LOCATION]', description: 'location_code', visible: true },
            { label: '[NOMBREAGENTE]', description: 'agent_fullname', visible: true }
        ]
    },
    {
        title: 'Totals',
        type: 'columns',
        fields: [
            { label: '[TOTALPIEZAS]', description: 'total_pieces', visible: true },
            { label: '[TOTALPESO]', description: 'total_weight', visible: true },
            { label: '[TOTALVOLUMEN]', description: 'total_volume', visible: true }
        ]
    }
];

export default warehouseLabels;
